import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCheckbox
}
  from 'mdb-react-ui-kit';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom'; // Import useHistory for navigation
import { loginSuccess, logout } from '../slices/authSlice';
import { selectAuth } from '../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'
import Main_nouploads from '../components/branche/Main_nouploads'
import Nouploads_Defi from '../components/branche/Nouploads_Defi'
import Uploads_bydefi from '../components/branche/Uploads_bydefi'
import Uploads_bydistrict from '../components/branche/Uploads_bydistrict'
import No_login_Patrouille from '../components/branche/No_login_Patrouille'
import Uploads_Scoring from '../components/branche/Uploads_Scoring'
import Uploads_Today from '../components/branche/Uploads_Today'

// Function to handle test button click
const handleTestButtonClick = async () => {
  try {
    const response = await axios.get('/api/test'); // Call the /test endpoint
    console.log('Test Response:', response.data); // Log the response data
  } catch (error) {
    console.error('Error calling /api/test:', error); // Log any errors
  }
};

const GreenTab = styled(MDBTabsLink)`
    background-color: green; /* Change to your desired shade of green */
    color: white; /* Change text color if needed */
`;

function BrancheAdminPage() {




  const [justifyActive, setJustifyActive] = useState('tab1');;
  const navigate = useNavigate();
  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const dispatch = useDispatch()

  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };

  // Redirect to /loginbranche if not authenticated
  useEffect(() => {
    if (!isAuthenticated || !userInformation.Branche) {
      navigate("/loginbranche");
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated || !userInformation.Branche) {
    return null; // Return null while redirecting
  }

  return (

    <MDBContainer className="p-3 my-5 d-flex flex-column">

      <MDBTabs pills justify className='mb-3 d-flex flex-row justify-content-between'>
        <MDBTabsItem>
          <GreenTab onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'} style={{
            backgroundColor: justifyActive === 'tab1' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab1' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            No Uploads At All
          </GreenTab>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'} style={{
            backgroundColor: justifyActive === 'tab2' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab2' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            No Uploads Par Defi
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab3')} active={justifyActive === 'tab3'} style={{
            backgroundColor: justifyActive === 'tab3' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab3' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            View Uploads Troupe (Par Defi)
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab4')} active={justifyActive === 'tab4'} style={{
            backgroundColor: justifyActive === 'tab4' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab4' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            View Uploads Troupe (Par District)
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab5')} active={justifyActive === 'tab5'} style={{
            backgroundColor: justifyActive === 'tab5' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab5' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            Patrouille Never logged in
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab6')} active={justifyActive === 'tab6'} style={{
            backgroundColor: justifyActive === 'tab6' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab6' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            Today's Uploads
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab7')} active={justifyActive === 'tab7'} style={{
            backgroundColor: justifyActive === 'tab7' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab7' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            Not Scored
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab8')} active={justifyActive === 'tab8'} style={{
            backgroundColor: justifyActive === 'tab8' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab8' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            Scored
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      <MDBTabsContent>

        <MDBTabsPane open={justifyActive === 'tab1'}>
          <Main_nouploads />
        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab2'}>
          <Nouploads_Defi />
        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab3'}>
        <Uploads_bydefi />
        </MDBTabsPane>
        
        <MDBTabsPane open={justifyActive === 'tab4'}>
          <Uploads_bydistrict/>
        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab5'}>
          <No_login_Patrouille/>
        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab6'}>
          <Uploads_Today/>
        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab7'}>
          <Uploads_Scoring filter="unscored"/>
        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab8'}>
          <Uploads_Scoring filter="scored"/>
        </MDBTabsPane>


      </MDBTabsContent>
    </MDBContainer>

  );
}

export default BrancheAdminPage;